import React, { FC } from 'react';
import Head from 'next/head';
import { SearchInitiation } from 'shared/components/SearchInitiation';
import { SearchInitiationMobile } from 'shared/components/SearchinitiationMobile';
import { BuyRentTabs } from '../BuyRentTabs/BuyRentTabs';
import { HeroContainerProps } from './HeroContainer.types';
import {
    SearchInitiationWrapper,
    DesktopSearchInputWrapper,
    MobileMainHeadline,
    DesktopMainHeadline,
    SearchBarWrapper,
    MobileSearchInputTitle,
    DesktopSearchInputTitle,
    HeroImage,
    MobileHeroContentWrapper
} from './HeroContainer.styles';

const mobileModalUpdateResultsText = "Let's get started";

const IMAGE_WIDTH = 1312;
const IMAGE_HEIGHT = 800;

export const HeroContainer: FC<HeroContainerProps> = ({
    tabSelected,
    setTabSelected,
    brandHeadline,
    title,
    image = {},
    mainContentId = 'main-content'
}) => {
    const {
        focalPoint: { focalPoint } = {},
        altText,
        image: { url } = {}
    } = image;

    return (
        <>
            <SearchInitiationWrapper>
                <Head>
                    <link
                        href={`${url}?fm=jpg&w=960&q=85&fl=progressive`}
                        rel="preload"
                        as="image"
                        media="(max-width: 960px)"
                    />
                    <link
                        href={`${url}?fm=jpg&w=1312&h=800&q=85&fl=progressive`}
                        rel="preload"
                        as="image"
                        media="(min-width: 960.1px)"
                    />
                </Head>
                <HeroImage
                    src={url || ''}
                    focalPoint={focalPoint}
                    width={IMAGE_WIDTH}
                    height={IMAGE_HEIGHT}
                >
                    <span role="img" aria-label={altText}></span>
                </HeroImage>
                <MobileHeroContentWrapper>
                    <MobileMainHeadline size="6">
                        {brandHeadline}
                    </MobileMainHeadline>
                    <MobileSearchInputTitle size="6">
                        {title}
                    </MobileSearchInputTitle>
                    <SearchInitiationMobile
                        showRadius={false}
                        searchType={tabSelected}
                        updateResultsText={mobileModalUpdateResultsText}
                        eventCategory="homepage"
                        searchSource="home"
                        excludePageSize
                    />
                </MobileHeroContentWrapper>

                <DesktopSearchInputWrapper>
                    <>
                        <DesktopSearchInputTitle id={mainContentId}>
                            {title}
                        </DesktopSearchInputTitle>
                        <BuyRentTabs
                            onPress={setTabSelected}
                            selected={tabSelected}
                            includeHousePrices
                            testIdSuffix={'desktop-homepage'}
                        />
                        <SearchBarWrapper>
                            <SearchInitiation
                                showRadius={false}
                                searchType={tabSelected}
                                eventCategory="homepage"
                                searchSource="home"
                                excludePageSize
                            />
                        </SearchBarWrapper>
                        <DesktopMainHeadline color="white" size="2">
                            {brandHeadline}
                        </DesktopMainHeadline>
                    </>
                </DesktopSearchInputWrapper>
            </SearchInitiationWrapper>
        </>
    );
};
